import { CreateMergeFieldDto, GeneralSettingsDto } from '@lmt/shared-types';

export type GeneralSettingsData = GeneralSettingsDto & {
  fileNameExpression: string;
};

export const defaultGeneralSettingsData: GeneralSettingsData = {
  isPatientCreatingShortedFormEnabled: false,
  isVisitCreatingShortedFormEnabled: false,
  fileNameExpression: '',
  serverLocale: 'en',
};

export const dfnMergeFieldData: CreateMergeFieldDto = {
  prefix: 'DFN',
  expression:
    "patient()['Number'] + '_' + file()['Name'] + '_' + file()['Version'] + '_' + formatDate(file()['UploadDateTime'], 'yyyyMMddHHmmss') + '.' + file()['Extension']",
  code: 0,
  name: 'File - Download file name',
  isInterpretationsActive: false,
};
